import React from "react";
import toast from "react-hot-toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CustomToast = ({
  position,
  title,
  toastType,
  fontawesomeIcon,
  duration = 10000,
}) => {
  let styling = {};
  if (toastType === "success") {
    styling = {
      background: "#80d4ae",
      color: "white",
    };
  }
  if (toastType === "error") {
    styling = {
      background: "rgba(235, 87, 87,0.8)",
      color: "white",
    };
  }
  if (toastType === "warning") {
    styling = {
      background: "#fff3cd",
      color: "#333",
    };
  }

  toast(title, {
    duration,
    position,
    // Styling
    style: styling,
    className: "",
    // Custom Icon
    icon: (
      <FontAwesomeIcon icon={fontawesomeIcon} style={{ marginRight: 10 }} />
    ),
  });
};

export default CustomToast;
